import { Flow_0_0_2 } from '@flexus/core';

export const BUI_2: Flow_0_0_2 = {
	id: '2',
	name: 'sp_allocated',
	itemType: 'flow',
	header: {
		title: 'SP Allocated',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Placeholder'
		},
		viewRoles: {
			0: 'Placeholder'
		}
	},
	startNode: '',
	nodes: {}
};
